import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'BNCC',
    path: '/academico/BNCC',
    name: 'BNCC',
    component: () => import('@/views/academico/BNCC/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.DIARIO_MENU_300300010
      ],
    },
    goesToMenu: true,
  },
]

